module.exports = __webpack_public_path__ + "img/1293203.png";